import { action } from 'typesafe-actions';
import { AuthTypes } from './types';

export const signInRequest = (code: string) =>
  action(AuthTypes.SIGN_IN_REQUEST, { code });

export const signInSuccess = (data: any) =>
  action(AuthTypes.SIGN_IN_SUCCESS, { data });

export const signFailure = () => action(AuthTypes.SIGN_FAILURE, {});

export const signedRequest = () => action(AuthTypes.SIGNED_REQUEST, {});

export const signedSuccess = (data: any, info: any) =>
  action(AuthTypes.SIGNED_SUCCESS, { data, info });

export const signedFailure = () => action(AuthTypes.SIGNED_FAILURE, {});

export const signOutRequest = () => action(AuthTypes.SIGNOUT_REQUEST, {});

export const signOutSuccess = () => action(AuthTypes.SIGNOUT_SUCCESS, {});

export const signOutFailure = () => action(AuthTypes.SIGNOUT_FAILURE, {});

export const companyRequest = (company: string, code?: string) =>
  action(AuthTypes.COMPANY_REQUEST, { company, code });

export const companySuccess = (data: any) =>
  action(AuthTypes.COMPANY_SUCCESS, { data });

export const companyFailure = () => action(AuthTypes.COMPANY_FAILURE, {});
